export default __webpack_public_path__ + "static/media/faq3.01374e60.png";